import React from 'react';
import { Box, Skeleton, Stack, Typography } from '@mui/material';

type NumberInfoProps = {
  value: number;
  name: string;
  loading: boolean;
};

export const NumberInfo: React.FC<NumberInfoProps> = ({
  value,
  name,
  loading,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      {loading ? (
        <Skeleton
          variant="rounded"
          height={80}
          width="100%"
          sx={{ borderRadius: 2 }}
        />
      ) : (
        <Stack alignItems="center" justifyContent="center">
          <Typography
            variant="h3"
            fontWeight={800}
            color="primary.main"
            sx={{
              p: 0.5,
              textAlign: 'center',
              lineHeight: 1,
              fontSize: { xs: '2rem', sm: '2.5rem', lg: '3rem' },
            }}
          >
            {value}
          </Typography>
          <Typography
            variant="caption"
            fontWeight={700}
            color="primary.main"
            sx={{
              textAlign: 'center',
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
            }}
          >
            {name}
          </Typography>
        </Stack>
      )}
    </Box>
  );
};

export default NumberInfo;
